import type {AuthProviderProps} from "react-oidc-context";
import {getAuthDomain, getAuthRealm } from "./services/envs";

const authDomain = getAuthDomain();
const hostname = `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}`;

export const oidcConfig: AuthProviderProps = {
  authority: `${authDomain}/realms/${getAuthRealm()}`,
  client_id: "portal-web",
  redirect_uri: `${hostname}/auth/callback`,
  post_logout_redirect_uri: hostname,
  response_type: "code",
  scope: "openid profile email",
  onSigninCallback: () => {
    // remove ?code=...&state=... from URL after login
    window.history.replaceState({}, document.title, window.location.pathname);
  }
};